<template>
    <vk-tabs-vertical keep-alive>
        <vk-tabs-item title="ROUBO" style="padding-top: 20px">
            <div class="rows" style="height: 250px;">
                <div class="col-sm-3">
                    <habilitar-alerta-transmissao class="btn-block" :veiculo="veiculo" @reload="reload($event)"/>
                </div>
                <div class="col-sm-9 " style="margin-top: 5px">
                    ESTE ALERTA HABILITA QUE NOTIFIQUE CASO TENHA ALGUMA TRANSMISSÃO DO VEÍCULO
                </div>
            </div>
        </vk-tabs-item>
        <vk-tabs-item title="OFICINA">
            <div class="rows" style="height: 250px">
                <div class="col-sm-12">
                    <habilitar-oficina @reload="reload($event)" :veiculo="veiculo"></habilitar-oficina>
                </div>
            </div>
        </vk-tabs-item>

        <vk-tabs-item title="MANUTENÇÕES">
            <div class="rows" style="height: 250px">
                <div class="col-sm-12">
                    <habilitar-sinistro @reload="reload($event)" :veiculo="veiculo"></habilitar-sinistro>
                </div>
            </div>
        </vk-tabs-item>
    </vk-tabs-vertical>
</template>

<script>
import HabilitarOficina from "../buttons/HabilitarOficina";
import HabilitarSinistro from "../buttons/HabilitarSinistro";
import HabilitarAlertaTransmissao from "../buttons/HabilitarAlertaTransmissao";
export default {
    name: "Problemas",
    components: {HabilitarAlertaTransmissao, HabilitarSinistro, HabilitarOficina},
    props: {
        veiculo: {
            default: null
        }
    },
    methods: {
        reload ($ev) {
            this.$emit('reload', $ev);
        }
    }
}
</script>

<style scoped>

</style>
